import { gql } from "lib/apolloClient";
import { studentGoalTask } from "Teacher/routes/StudentGoals/components/GoalList/modules/GoalListFragments";

export const createPostMutation = gql`
  mutation createPost(
    $createdBy: ID!
    $attachments: [AttachmentInput!]
    $state: PostStateEnum!
    $publishedBy: ID!
  ) {
    documentation {
      createPost(
        input: {
          createdBy: $createdBy
          attachments: $attachments
          state: $state
          publishedBy: $publishedBy
        }
      ) {
        id
      }
    }
  }
`;

export const updateGoalTaskMutation = gql`
  mutation updateGoalTask($input: GoalTaskUpdateInput!) {
    documentation {
      updateGoalTask(input: $input) {
        ...goalTaskItem
      }
    }
  }
  ${studentGoalTask}
`;

export const addEvidencesForStudentGoalsMutation = gql`
  mutation addEvidencesForStudentGoal($input: StudentGoalEvidenceInput!) {
    documentation {
      addEvidencesForStudentGoal(input: $input) {
        id
        evidenceType
        evidenceItem {
          ... on Post {
            id
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const markCommentsReadForFieldMutation = gql`
  mutation markCommentsReadForField($input: [UpdateEntityIsReadInput!]) {
    platform {
      updateEntityIsReadInBulk(input: $input) {
        isSuccess
      }
    }
  }
`;
